import { useEffect } from "react";
import { mountStoreDevtool } from "simple-zustand-devtools";
import { isDev } from "./env";

export function useZustandDevtool(...arg) {
  if (!isDev()) return;
  mountStoreDevtool(...arg);
}
